<template>
  <div class="right-wrapper">
    <div class="title">数据统计</div>
    <el-scrollbar class="scrollbar-main">
      <div class="data-list">
        <div class="data-box">
          <div class="data-title">
            <DataTitle :title="title"></DataTitle>
          </div>
          <el-row class="content" :gutter="8">
            <el-col :span="12" v-for="(item, index) in statusTypeAreaData" :key="`status_${index}`"
              style="margin-bottom: 8px">
              <div class="box1">
                <div class="num">{{ item.num }}</div>
                <div class="text">{{ item.label }}</div>
              </div>
            </el-col>
          </el-row>
        </div>
        <!-- 土地类型统计 -->
        <div class="data-box">
          <div class="data-title">
            <DataTitle :title="title2"></DataTitle>
          </div>
          <div style="height: 150px">
            <MyEchart :option="chartOption1"></MyEchart>
          </div>
        </div>
        <div class="data-box">
          <div class="data-title">
            <DataTitle :title="title3"></DataTitle>
          </div>
          <el-row class="content" :gutter="8">
            <el-col :span="12">
              <div class="box1">
                <div class="num">{{ flyCountData.thisMonth }}</div>
                <div class="text">本月巡查次数</div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="box1">
                <div class="num">{{ flyCountData.total }}</div>
                <div class="text">巡查总次数</div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="data-box">
          <!-- 整改统计 -->
          <div class="data-title">
            <DataTitle :title="title4"></DataTitle>
          </div>
          <div style="height: 150px">
            <MyEchart :option="chartOption2"></MyEchart>
          </div>

          <div class="spot-check-list">
            <div class="list-title">整改详情列表</div>
            <div class="list-table">
              <el-table :data="tableData" border style="width: 100%" v-el-table-infinite-scroll="loadMore"
                height="200px" :header-cell-style="{
                    background: '#102A7C',
                    border: '1px solid #38509D',
                    color: '#fff',
                }" :cell-style="{ border: '1px solid #38509D' }">
                <el-table-column prop="name" label="整改地块" align="center">
                </el-table-column>
                <el-table-column prop="progress" label="整改进度" align="center">
                  <template slot-scope="scope">
                    <div>{{ scope.row.isComplete === 1 ? '未整改' : '整改' }}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="completeDate" label="整改日期" align="center">
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
import ElTableInfiniteScroll from 'el-table-infinite-scroll';
import DataTitle from '../components/dataTitle.vue';
import * as Api from './Api';
import DicMixin from '../mixins/DicMixin';
import MyEchart from '../components/MyEchart';

export default {
    mixins: [DicMixin],
    directives: {
        'el-table-infinite-scroll': ElTableInfiniteScroll,
    },
    components: {
        DataTitle,
        MyEchart,
    },
    data () {
        return {
            title: '收储情况(单位：平方米)',
            title2: '土地类型',
            title3: '无人机巡查信息',
            title4: '监察抽查/整改统计',
            tableData: [
                // {
                //     plot: '地块名称',
                //     progress: '已完成',
                //     date: '2022-01-02',
                // },
                // {
                //     plot: '地块名称',
                //     progress: '已完成',
                //     date: '2022-01-02',
                // },
            ],
            statusTypeAreaList: [], // 收储情况数据
            landTypeCountList: [], // 土地类型统计数据

            flyCountData: {
                // 飞行巡查统计数据
                thisMonth: '', // 本月巡查次数
                total: '',
            },
            zhenggaiData: [
                {
                    value: 0,
                    name: '未整改',
                },
                {
                    value: 0,
                    name: '已整改',
                },
            ], // 整改统计数据
        };
    },
    computed: {
    // 收储情况统计数据
        statusTypeAreaData () {
            let list = [];
            let statusTypeAreaList = this.statusTypeAreaList;
            let statusDic = this.mixin_LandStatusDic; // 状态数据字典

            if (Array.isArray(statusTypeAreaList)) {
                statusTypeAreaList.forEach((item) => {
                    let landStatus = item.landStatus;
                    let obj = {
                        ...item,
                        label: statusDic[landStatus],
                    };
                    obj.num = this.formatterNumber(item.num);
                    if (landStatus === 'total') {
                        obj.label = '总数';
                    }
                    list.push(obj);
                });
            }

            return list;
        },
        landTypeCountChartData () {
            let list = [];
            let countList = this.landTypeCountList;
            let dic = this.mixin_LandTypeDic;

            if (Array.isArray(countList)) {
                countList.forEach((item) => {
                    let key = item.type;
                    let obj = {
                        value: item.num,
                        name: dic[key],
                    };
                    list.push(obj);
                });
            }

            return list;
        },
        chartOption1 () {
            let data = this.landTypeCountChartData || [];
            return {
                color: ['#0263FF', '#FF7723', '#8E30FF', '#2C46E8'],
                tooltip: {
                    trigger: 'item',
                },
                legend: {
                    orient: 'vertical',
                    top: '20',
                    right: '20',
                    textStyle: {
                        color: '#FFF',
                        rich: {
                            b: {
                                padding: [0, 0, 0, 20],
                                color: '#49F0FD',
                            },
                        },
                    },
                    formatter: (name) => {
                        let value = '';
                        data.forEach((item) => {
                            if (item.name === name) {
                                value = item.value;
                            }
                        });
                        return `${name}{b|${value}}`;
                    },
                },
                series: [
                    {
                        type: 'pie',
                        center: ['25%', '50%'],
                        radius: '80%',
                        itemStyle: {
                            normal: {
                                borderWidth: 3,
                                borderColor: '#000',
                            },
                        },
                        label: {
                            normal: {
                                position: 'inner',
                                show: false,
                            },
                        },
                        // data: [
                        //     // { value: 12, name: '工厂用地' },
                        //     // { value: 44, name: '办公用地' },
                        //     // { value: 56, name: '园区用地' },
                        //     // { value: 56, name: '住宅用地' },
                        // ],
                        data,
                    },
                ],
            };
        },
        chartOption2 () {
            let data = this.zhenggaiData || [];
            return {
                // color: ['#0263FF', '#FF7723', '#8E30FF', '#2C46E8'],
                color: ['#0263FF', '#E4335E'],
                tooltip: {
                    trigger: 'item',
                },
                legend: {
                    orient: 'vertical',
                    top: '20',
                    right: '20',
                    textStyle: {
                        color: '#FFF',
                        rich: {
                            b: {
                                padding: [0, 0, 0, 20],
                                color: '#49F0FD',
                            },
                        },
                    },
                    formatter: (name) => {
                        let value = '';
                        data.forEach((item) => {
                            if (item.name === name) {
                                value = item.value;
                            }
                        });
                        return `${name}{b|${value}}`;
                    },
                },
                series: [
                    {
                        type: 'pie',
                        center: ['25%', '50%'],
                        radius: '80%',
                        itemStyle: {
                            normal: {
                                borderWidth: 3,
                                borderColor: '#000',
                            },
                        },
                        label: {
                            normal: {
                                position: 'inner',
                                show: false,
                            },
                        },
                        // data: [
                        //     // { value: 12, name: '工厂用地' },
                        //     // { value: 44, name: '办公用地' },
                        //     // { value: 56, name: '园区用地' },
                        //     // { value: 56, name: '住宅用地' },
                        // ],
                        data,
                    },
                ],
            };
        },
    },

    methods: {
    /**
     * 收储情况统计(根据土地状态统计面积)
     */
        getAreaCount () {
            Api.fetchCountArea()
                .run()
                .then((res) => {
                    let list = res || [];
                    this.statusTypeAreaList = list;
                });
        },
        /**
     * 根据土地类型统计面积
     */
        getLandTypeCount () {
            Api.fetchCountLandByType()
                .run()
                .then((res) => {
                    let list = res || [];
                    this.landTypeCountList = list;
                });
        },
        /**
     * 统计无人机巡查次数
     */
        getFlyCount () {
            Api.fetchFlyCount()
                .run()
                .then((res) => {
                    let data = {};
                    let list = res || [];
                    if (list.length > 0) {
                        data = list[0];
                    }
                    this.flyCountData = data;
                });
        },

        /**
     * 查询整改统计
     */
        getRectifyCount () {
            let params = {
                type: 'TD', // 固定参数
            };
            Api.fetchRectifyCount(params)
                .run()
                .then((res) => {
                    let list = res || [];
                    let result = this.zhenggaiData;
                    list.forEach((item) => {
                        let isComplete = `${item.isComplete}`;
                        let num = item.num;
                        if (isComplete === '1') {
                            result[0].value = num;
                        } else if (isComplete === '0') {
                            result[1].value = num;
                        }
                    });
                    this.zhenggaiData = result;
                });
        },

        /**
     * 查询整改列表
     */
        getRectifyList () {
            let list = [];
            let params = {
                type: 'TD', // 固定参数
            };
            Api.fetchRectifyList(params)
                .run()
                .then((res) => {
                    list = res || [];
                    this.tableData = list;
                });
        },
        loadMore () {
            console.log(1222);
        },
        // 获取数据字典
        getDic () {
            this.mixinGetLandTypeDic();
            this.mixinGeLandStatusDic();
        },
        // 获取统计数据
        getData () {
            this.getAreaCount();
            this.getLandTypeCount();
            this.getFlyCount();
            this.getRectifyCount();
            this.getRectifyList();
        },
        // 数字3位数加分隔符
        formatterNumber (num, split = ',') {
            let str = '';
            let reg = /(?=(?!\b)(\d{3})+$)/g;
            let res = '';
            if (num !== undefined) {
                str = `${num}`;
                res = str.toString().replace(reg, split);
            }

            return res;
        },
    },
    created () {
        this.getDic();
    },
    mounted () {
        this.getData();
    },
};
</script>

<style lang="scss" scoped>
@import '~@Theme/config.scss';
@import '~@Theme/mixins/index.scss';

.right-wrapper {
  height: inherit;
  position: relative;

  .title {
    padding-top: 11px;
    text-align: center;
    font-size: 18px;
    height: 37px;
    background-image: url(../imgs/titlebg01.png);
  }

  .scrollbar-main {
    // height: 800px;
    height: calc(100% - 48px - 10px);
    overflow-x: hidden;
  }

  ::v-deep .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  ::v-deep .el-table {
    background-color: #071150;

    tr {
      background-color: #071150;
      color: #fff;
    }
  }

  ::v-deep .el-table--enable-row-hover {
    .el-table__body tr:hover>td.el-table__cell {
      background-color: #19267c;
    }
  }

  // //修改表格边框颜色

  .el-table--border:after,
  .el-table--group:after,
  .el-table:before {
    background-color: #38509d;
  }

  .el-table--border,
  .el-table--group {
    border-color: #38509d;
  }

  .el-table td,
  .el-table th.is-leaf {
    border-color: #38509d;
  }

  .el-table--border th,
  .el-table--border th.gutter:last-of-type {
    border-color: #38509d;
  }

  .el-table--border td,
  .el-table--border th {
    border-color: #38509d;
  }

  .data-list {
    margin-top: 15px;
    padding: 0 16px;

    .data-box {
      margin-top: 30px;

      .content {
        margin-top: 15px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        .box1 {
          // width: 141px;
          height: 63px;
          background-color: #102a7c;
          display: flex;
          box-sizing: border-box;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          .num {
            text-align: center;
            font-size: 20px;
            margin-top: 8px;
            height: 23px;
            line-height: 23px;
            font-weight: bold;
          }

          .text {
            font-size: 14px;
            text-align: center;
            margin-top: 5px;
            opacity: 0.6;
          }
        }

        .land-type {
          width: 100%;
          display: flex;

          .land-type-num {
            margin-top: 30px;

            .type {
              padding-top: 5px;

              .factory {
                display: inline-block;
                width: 12px;
                height: 12px;
                background-color: #0263ff;
                margin-right: 5px;
              }

              .office {
                display: inline-block;
                width: 12px;
                height: 12px;
                background-color: #ff7723;
                margin-right: 5px;
              }

              .park {
                display: inline-block;
                width: 12px;
                height: 12px;
                background-color: #8e30ff;
                margin-right: 5px;
              }

              .home {
                display: inline-block;
                width: 12px;
                height: 12px;
                background-color: #2c46e8;
                margin-right: 5px;
              }

              .num {
                margin-left: 5px;
                color: #49f0fd;
              }
            }
          }
        }

        .spot-check {
          width: 100%;
          display: flex;

          .spot-check-num {
            margin-top: 30px;

            .type {
              padding-top: 5px;

              .rectify {
                display: inline-block;
                width: 12px;
                height: 12px;
                background-color: #0263ff;
                margin-right: 5px;
              }

              .not-rectify {
                display: inline-block;
                width: 12px;
                height: 12px;
                background-color: #e4335e;
                margin-right: 5px;
              }

              .total {
                margin-right: 33px;
              }

              .num {
                margin-left: 5px;
                color: #49f0fd;
              }
            }
          }
        }
      }

      .list-title {
        text-align: center;
      }

      .list-table {
        margin-top: 12px;
      }
    }
  }
}
</style>
